import { render, staticRenderFns } from "./flag-ca.vue?vue&type=template&id=7717575c"
import script from "./flag-ca.vue?vue&type=script&lang=js"
export * from "./flag-ca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports